import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex bg-[var(--el-bg-color-overlay)] p-12px mb-12px rounded-1"
};
const _hoisted_2 = {
  class: "bg-black bg-op-40 absolute top-0 left-0 w-full h-full flex items-center justify-center cursor-pointer"
};
const _hoisted_3 = {
  class: "ml-8px"
};
const _hoisted_4 = {
  class: "mt-8px text-12px text-[var(--el-text-color-secondary)] line-clamp-2"
};
import { inject } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Index'
  },
  __name: 'index',
  props: {
    songInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['play'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const currentSong = inject('currentSong', {});
    function playSong() {
      emits('play');
    }
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "relative",
        onClick: playSong
      }, [_createVNode(_component_el_image, {
        src: __props.songInfo.imageUrl,
        class: "flex-none w-80px"
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_Icon, {
        icon: _unref(currentSong).id === __props.songInfo.id ? 'solar:pause-circle-bold' : 'mdi:arrow-right-drop-circle',
        size: 30
      }, null, 8, ["icon"])])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(__props.songInfo.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.songInfo.desc), 1)])]);
    };
  }
});